import { Component, Input } from '@angular/core';
import { MatDrawer, MatSidenav } from '@angular/material/sidenav';
import { nav_path } from 'src/app/app-routing.module';
import { companyInformation } from '../../../../companyinformation';
import { AuthService } from '../../../../core/services/auth.service';
import { MenuService } from '../../../services/menu.service';

@Component({
  selector: 'anon-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() sidenav!: MatSidenav | MatDrawer;
  company = companyInformation;
  nav_path = nav_path;
  public userPhotoError: boolean = false;

  constructor(
    public authService: AuthService,
    public menuService: MenuService
  ) {}


}
